var module;
// LICENSE_CODE ZON
'use strict'; /*jslint node:true, browser:true*/

var is_node = typeof module == 'object' && module.exports;
if (is_node) ;else ;
define(['virt_jquery_all', '/www/hola/pub/lib/model.ts', '/util/escape.js', '/www/hola/pub/util.js', '/util/etask.js', 'zutil', 'lodash.debounce', 'lodash.toarray', '/www/hola/pub/unblock_util.js', '/util/user_agent.js', 'pub_config', '/svc/vpn/pub/util.js', 'hola_opt', '/util/events.js', '/util/storage.js', '/svc/hola/pub/svc_ipc.js', '/util/zerr.js', '/util/url.js', '/util/util.js', '/svc/account/pub/membership.js', 'cookie', '/www/hola/pub/app_checker.js'], function ($, hola_model, zescape, www_util, etask, _, _debounce, _toArray, uutil, user_agent, config, svc_util, hopt, events, storage, svc_ipc, zerr, zurl, zutil, membership, cookie, app_checker) {
  var E = new hola_model.Model();
  var assign = Object.assign;
  var perr_url = config.perr_url;
  var ccgi_url = config.ccgi_url;
  var url_o = zurl.parse(location.href);
  var qs_o = zurl.qs_parse((url_o.search || '').substr(1), {
    safe: true
  });
  E.ext = function () {
    return E.get('ext.info');
  };
  E.can_use_ext = function () {
    return E.ext() || config.get_hola_extension_info();
  };
  E.svc = function () {
    var v;
    return E.get('svc.info') || (v = E.ext()) && v.svc_info;
  };
  E.is_svc = function () {
    // hola firefox plugin is filtered
    return E.svc() && !/\bhola_plugin/.test(E.svc().exe);
  };
  E.has_hola = function () {
    return E.ext() || E.svc();
  };
  E.is_plugin = function () {
    return E.ext() && E.ext().plugin;
  };
  E.build_info = function () {
    var build_info = zutil.clone(E.ext() && E.ext().build_info) || {
      platform: navigator.platform,
      user_agent: navigator.userAgent
    };
    build_info.www_version = hopt.version;
    return build_info;
  };
  E.ios_email_cancel = function () {
    storage.set('ios_email_collect_cancelled', true);
  };
  E.ios_email_submit = function () {
    storage.set('ios_email_collect_submitted', true);
  };
  E.build = function () {
    var info = E.build_info(),
      s = '';
    for (var f in info) s += (s && '\n') + f + ': ' + info[f];
    return s;
  };

  /* XXX arik: add browser,... (copy from extension ajax requests ) */
  E.auth = function (_o) {
    var o = zutil.clone(_o || {}),
      uid;
    o.session_key = E.get('session_key');
    if (uid = E.get('cid')) o.cid = uid;else if (uid = E.get('uuid')) o.uuid = uid;
    return o;
  };
  E.updater_callback = function () {
    return etask([function try_catch$() {
      return svc_ipc.ajax({
        cmd: 'callback.json',
        up: true
      });
    }, function (ret) {
      var e;
      if (ret) e = ret.ret;
      if (this.error) {
        if (this.error.message == 'timeout') return this.throw('timeout');
        return this.throw('updater error ' + this.error);
      }
      if (!e || !e.exe || e.exe != 'hola_updater.exe') return this.throw('invalid updater response');
      return e;
    }]);
  };
  E.svc_callback = function () {
    return etask([function try_catch$() {
      if (E.svc_callback.use_ext) return this.goto('ext');
      return svc_ipc.ajax('callback.json');
    }, function (ret) {
      var e, xhr;
      if (ret) {
        e = ret.ret;
        xhr = ret.xhr;
      }
      if (!this.error) return this.goto('res', e);
      if (this.error.message == 'timeout') return this.throw('timeout');
      // xhr.statusText will contain 'nsresult: "0x805e0006 (<unknown>)"'
      // if firefox blocked mixed content, in that case we fallback to use
      // extension, otherwise, we propagate error
      // XXX bahaa: try to use extension anyway on chrome and firefox
      if (location.protocol != 'https:' || !E.is_firefox() || !xhr || !xhr.statusText.includes('0x805e0006')) {
        throw new Error(xhr ? xhr.statusText : 'no xhr');
      }
      return this.goto('res');
    }, function catch$() {}, function ext() {
      // firefox blocked mixed content, try to get info from ext
      return etask([function () {
        return www_util.msg_post_recv({
          msg: {
            src: 'hola_ccgi',
            id: 'svc_callback'
          }
        });
      }, function (data) {
        if (!data || !data.data || !data.data.from_be) throw new Error('svc_callback from be failed');
        E.svc_callback.use_ext = 1;
        return data.data;
      }, function catch$(err) {
        throw err;
      }]);
    }, function res(data) {
      if (data && data.exe && data.exe.includes('hola_plugin') && !E.is_plugin()) {
        // XXX bahaa: remove this once extensions know how to work with a
        // plugin from another browser
        throw new Error('plugin outside this browser');
      }
      var need_recheck = !data || !window.hola_svc_info || window.hola_svc_info.ver != data.ver;
      window.hola_svc_info = data;
      E.set('svc.info', window.hola_svc_info);
      // XXX colin/arik: storage_set_json used null, this had caused
      // the string to be set as "null" please check this out and remove
      storage.set_json('unblock.svc.info', E.get('svc.info'));
      if (need_recheck) app_checker._check_svc();
      return window.hola_svc_info;
    }, function catch$(err) {
      delete window.hola_svc_info;
      E.unset('svc.info');
      storage.set_json('unblock.svc.info', E.get('svc.info'));
      throw err;
    }]);
  };
  E.ext_callback = function (no_trigger) {
    no_trigger = no_trigger || false;
    return etask([function () {
      return www_util.check_ext();
    }, function (info) {
      var data = info && info.data;
      config.set_hola_extension_info(data);
      E.set('ext.info', data, {
        silent: no_trigger
      });
      storage.set('unblock.had_ext', 1);
      storage.set_json('unblock.ext.info', E.get('ext.info'));
      return data;
    }, function catch$(err) {
      // XXX sergeir: debugging be.ext undefined
      if (config.get_hola_extension_info()) E.perr({
        id: 'www_ext_callback_err',
        bt: err.stack,
        info: '' + err
      });
      config.set_hola_extension_info(null);
      E.unset('ext.info');
      storage.set_json('unblock.ext.info', E.get('ext.info') || null);
      throw err;
    }]);
  };
  E.ext_open_be_tab = function (url) {
    return www_util.post_msg({
      src: 'hola_ccgi',
      id: 'open_be_tab',
      opt: {
        url: url,
        force_active: true
      }
    });
  };
  E.update_info = function () {
    if (E.get('cid')) return E.svc_callback();
    return E.ext_callback();
  };
  function update_info_init() {
    var ext_info_fail_count = 0,
      retry_count = 0;
    etask([function () {
      E.update_info_sp = this;
    }, function try_catch$loop() {
      return E.ext_callback();
    }, function try_catch$() {
      return E.svc_callback();
    }, function () {
      var ext = E.get('ext.info');
      var svc = E.get('svc.info');
      if (ext || svc && ++ext_info_fail_count > 10) return this.return();
      retry_count++;
      this.set_state('loop');
      return etask.sleep(retry_count < 20 ? 1000 : 5000);
    }, function finally$() {
      E.update_info_sp = null;
    }]);
  }
  E._rule_set = function (_opt) {
    var opt = zutil.clone(_opt || {});
    opt.plugin = +!!E.is_plugin();
    return etask([function () {
      if (!E.ext() || !opt.type || !opt.md5) {
        return www_util.ajax({
          dataType: 'text',
          type: 'POST',
          data: opt,
          url: E.get('url_ccgi') + '/rule_set.json?' + zescape.qs(E.auth())
        });
      }
      return etask([function () {
        return www_util.msg_post_recv({
          msg: {
            src: 'hola_ccgi',
            id: 'set_rule',
            opt: opt
          },
          timeout: 20000
        });
      }, function (e) {
        if (!e || !e.data || e.data.err) throw new Error(e.data.err || 'set_rule failed');
        return e.data;
      }]);
    }, function () {
      www_util.post_msg({
        src: 'hola_ccgi',
        id: 'update_rules'
      });
    }]);
  };
  E.rule_set = function (rule, on, opt) {
    return E._rule_set(assign({
      enabled: +!!on
    }, _.pick(rule, 'sid', 'name', 'type', 'md5', 'country'), opt));
  };
  E.enable_root_url = function (opt) {
    zerr.assert(zurl.is_valid_domain(opt.root_url), 'Invalid root url:' + opt.root_url);
    // XXX arik: enable for svc
    if (!app_checker.is_ext()) throw new Error('enable_root_url not supported for svc');
    return etask([function () {
      return www_util.msg_post_recv({
        msg: {
          src: 'hola_ccgi',
          id: 'enable_root_url',
          opt: opt
        },
        timeout: 20000
      });
    }, function (e) {
      if (!e || !e.data || e.data.err) throw new Error(e.data.err || 'enable_root_url failed');
      return e.data;
    }]);
  };
  E.enable_unblocker = function (reload) {
    if (!E.get('cid') || E.get('svc.unblocker.enabled')) return;
    return etask([function () {
      return www_util.msg_post_recv({
        msg: {
          src: 'hola_ccgi',
          id: 'vpn_enable'
        }
      });
    }, function (e) {
      if (e.data.err) throw new Error(e);
      return E.update_info();
    }]);
  };
  E.get_unblocking_rates = function (limit) {
    var adult_content = cookie.get('adult_content');
    return etask([function () {
      return www_util.ajax({
        dataType: 'json',
        type: 'GET',
        data: {
          limit: limit,
          src_country: (E.get('src_country') || '').toLowerCase(),
          adult_content: adult_content
        },
        url: E.get('url_ccgi') + '/unblocking_rate?' + zescape.qs(E.auth())
      });
    }]);
  };
  E.force_suggestion = function () {
    return www_util.msg_post_recv({
      msg: {
        src: 'hola_ccgi',
        id: 'force_suggestion'
      },
      timeout: 2000
    });
  };
  E.set_dont_show_again = function (opt) {
    return www_util.msg_post_recv({
      msg: {
        src: 'hola_ccgi',
        data: opt,
        id: 'set_dont_show_again'
      }
    });
  };
  E.set_svc_downloaded = function () {
    return www_util.msg_post_recv({
      msg: {
        src: 'hola_ccgi',
        data: {
          ts: Date.now()
        },
        id: 'set_svc_downloaded'
      }
    });
  };
  E.is_dont_show = function (opt) {
    return etask([function () {
      return www_util.msg_post_recv({
        msg: {
          src: 'hola_ccgi',
          data: opt,
          id: 'is_dont_show'
        }
      });
    }, function (e) {
      if (!e || !e.data || e.data.err) throw new Error(e.data.err || 'is_dont_show failed');
      return e.data;
    }]);
  };
  E.set_enabled_for_browser = function (opt) {
    return www_util.msg_post_recv({
      msg: {
        src: 'hola_ccgi',
        data: opt,
        id: 'set_enabled_for_browser'
      }
    });
  };
  E.is_enabled_for_browser = function () {
    return etask([function () {
      return www_util.msg_post_recv({
        msg: {
          src: 'hola_ccgi',
          data: {},
          id: 'is_enabled_for_browser'
        }
      });
    }, function (e) {
      if (!e || !e.data || e.data.err) throw new Error(e.data.err || 'is_enabled_for_browser failed');
      return e.data;
    }]);
  };
  E.get_browser_country = function (opt) {
    return www_util.msg_post_recv({
      msg: {
        src: 'hola_ccgi',
        data: opt,
        id: 'get_browser_country'
      }
    });
  };
  E.set_browser_country = function (opt) {
    return www_util.msg_post_recv({
      msg: {
        src: 'hola_ccgi',
        data: opt,
        id: 'set_browser_country'
      }
    });
  };
  E.get_full_browser_mode = function (opt) {
    return www_util.msg_post_recv({
      msg: {
        src: 'hola_ccgi',
        data: opt,
        id: 'get_full_browser_mode'
      }
    });
  };
  E.force_full_browser_mode = function (opt) {
    return www_util.msg_post_recv({
      msg: {
        src: 'hola_ccgi',
        data: opt,
        id: 'force_full_browser_mode'
      }
    });
  };
  E.set_browser_ab = function (opt) {
    return www_util.msg_post_recv({
      msg: {
        src: 'hola_ccgi',
        data: opt,
        id: 'set_browser_ab'
      }
    });
  };
  E.get_ext_timer = function (opt) {
    return www_util.msg_post_recv({
      msg: {
        src: 'hola_ccgi',
        data: opt,
        id: 'get_ext_timer'
      }
    });
  };
  E.get_shoop_version = function () {
    return www_util.msg_post_recv({
      msg: {
        target: 'shoop',
        src: 'hola_ccgi',
        id: 'get_version'
      }
    });
  };
  E.shoop_activate_url = function (url, opt) {
    return www_util.msg_post_recv({
      msg: {
        target: 'shoop',
        src: 'hola_ccgi',
        id: 'activate_url',
        args: [url, opt]
      }
    });
  };
  E.notify_survey_done = function (opt) {
    return www_util.msg_post_recv({
      msg: {
        src: 'hola_ccgi',
        data: opt,
        id: 'notify_survey_done'
      }
    });
  };
  E.is_android = function () {
    return user_agent.guess(navigator.userAgent).os == 'android';
  };
  E.is_win = function () {
    return user_agent.guess(navigator.userAgent).os == 'windows';
  };
  E.is_mac = function () {
    return user_agent.guess(navigator.userAgent).os == 'macos';
  };
  E.is_firefox = function () {
    return user_agent.guess_browser(navigator.userAgent).browser == 'firefox';
  };
  E.is_ie = function () {
    return user_agent.guess_browser(navigator.userAgent).browser == 'ie';
  };
  E.is_chrome = function () {
    return window.chrome;
  };
  E.product_info = function () {
    var info = {};
    var ext = E.ext(),
      svc = E.svc();
    info.server_version = config.ver;
    info.ext_version = ext && ext.ver;
    info.svc_mode = ext && ext.svc_mode;
    info.svc_mode_pending = ext && ext.svc_mode_pending;
    info.svc_version = svc && svc.ver;
    info.product_type = ext ? ext.type : svc ? 'svc' : '';
    info.browser = E.get('browser');
    var browser = user_agent.guess_browser();
    var browser_name = browser.opera ? 'opera' : browser.browser;
    info.browser2 = browser_name + ' ' + (browser_name == 'opera' ? browser.opera_version : browser.version);
    info.os = E.os_guess.os;
    info.platform = navigator && navigator.platform;
    info.cid = svc && svc.cid;
    info.uuid = ext && ext.uuid;
    return info;
  };

  // XXX alexeym: unify with bext/pub/about_main.js
  E.print_product_info = function (el, build, dev) {
    function add_line(s, val) {
      return s + val + '\n';
    }
    var s = '';
    if (build.ext_version) s += add_line('Ext version: ', build.ext_version);else {
      var ext_version = window.zon_config && window.zon_config.ZON_VERSION;
      if (ext_version) s += add_line('Ext version: ', ext_version);
    }
    if (build.server_version) s += add_line('WWW version: ', build.server_version);
    if (build.svc_version) {
      s += add_line('Service: ', build.svc_version, 'product-service-version');
    }
    if (build.svc_mode) {
      var mode = build.svc_mode + ' active';
      if (build.svc_mode_pending) mode += ', ' + build.svc_mode_pending + ' pending';
      s += add_line('Mode: ', mode);
    }
    if (build.product_type) s += add_line('Product: ', build.product_type);
    if (build.browser2) s += add_line('Browser: ', build.browser2);else if (build.browser) s += add_line('Browser: ', build.browser);
    if (build.platform) s += add_line('Platform: ', build.platform);
    var cid, uuid;
    if (E.be_bg_main) {
      if (E.be_bg_main.get('svc.cid')) cid = E.be_bg_main.get('svc.cid');
      uuid = E.be_bg_main.get('uuid');
    } else {
      cid = build.cid;
      uuid = build.uuid;
    }
    if (cid) s += add_line('CID: ', cid);
    if (uuid) s += add_line('UUID: ', uuid);
    if (dev) s += add_line('Dev info: ', dev);
    if (el && el[0]) el[0].innerText = s;
    return s;
  };
  E.fetch_rules = function () {
    /* XXX arik: cancel previous running etask */
    var auth = E.auth();
    if (!auth.session_key || !auth.cid && !auth.uuid) return E.unset('rules');
    return etask([function () {
      if (E.ext()) {
        return etask([function () {
          return www_util.msg_post_recv({
            msg: {
              src: 'hola_ccgi',
              id: 'fetch_rules'
            },
            timeout: 20000
          });
        }, function (e) {
          if (!e || !e.data || e.data.err) throw new Error(e.data.err || 'fetch_rule failed');
          return e.data.rules;
        }]);
      }
      return www_util.ajax({
        dataType: 'json',
        type: 'POST',
        data: {
          plugin: +!!E.is_plugin()
        },
        url: E.get('url_ccgi') + '/rules_get_settings.json?' + zescape.qs(E.auth())
      });
    }, function (e) {
      E.set('rules', e && e.unblocker_rules);
      storage.set_json('unblock.rules', E.get('rules'));
    }, function catch$(err) {
      E.perr({
        id: 'www_fetch_rules_err',
        bt: err.stack,
        info: '' + err
      });
    }]);
  };
  E.fetch_all = function () {
    return etask.all({
      rules: E.fetch_rules()
    });
  };
  function get_ratings_array(rules) {
    var n,
      r,
      a = [];
    var src_country = (E.get('src_country') || '').toLowerCase();
    for (n in rules) {
      r = rules[n];
      if (!r.root_url) continue;
      for (var i = 0; i < r.root_url.length; i++) {
        a.push(assign({
          src_country: src_country,
          root_url: uutil.get_root_url(r)
        }, _.pick(r, 'sid', 'name', 'type', 'md5')));
      }
    }
    return a;
  }
  E.fetch_ratings = function () {
    var rules = E.get('rules');
    if (!rules) return;
    var a = get_ratings_array(rules);
    if (!a.length) return;
    /* XXX arik: don't call it if E.get('ratings') matches list of rules */
    return etask([function () {
      return www_util.ajax({
        dataType: 'json',
        type: 'POST',
        data: {
          a: a
        },
        url: '/access/ratings?' + zescape.qs(E.auth())
      });
    }, function (e) {
      E.set('ratings', e.ratings);
      storage.set_json('unblock.ratings', E.get('ratings'));
    }, function catch$(err) {
      E.perr({
        id: 'www_fetch_ratings_err',
        bt: err.stack,
        info: '' + err
      });
    }]);
  };
  E.get_rate = function (ratings, rule) {
    for (var i = 0; i < ratings.length; i++) {
      var rate = ratings[i];
      if (!rate) continue;
      var r = svc_util.find_rule({
        a: rate
      }, rule);
      if (r) return rate;
    }
  };

  /* XXX arik/mark: mv to generic place */
  function stringify(o) {
    try {
      return JSON.stringify(o) || '';
    } catch (e) {
      return '[circular]';
    }
  }
  function log_to_body() {
    var body = document.body,
      msg = document.createElement('div');
    body.append(msg);
    msg.innerText = arguments[0] + ' ' + stringify(_toArray(arguments));
  }
  E.init_fetch_rules = function () {
    E.on('change:cid change:uuid change:session_key', _debounce(E.fetch_all));
  };

  /* XXX arik/mark: 1) use Backbone.localStorage?
   * 2) unite code with bext/pub/util.js */
  function storage_err(api, key, err) {
    console.error('%s failed %s %s %s', api, key, '' + err, err.stack);
    E.set('storage.err', (E.get('storage.err') || 0) + 1);
  }
  E.init = function (opt) {
    opt = opt || {};
    if (E.inited) return;
    storage.on_err = storage_err;
    E.inited = true;
    E.br_guess = user_agent.guess_browser(navigator.userAgent);
    E.os_guess = user_agent.guess(navigator.userAgent);
    E.set('src_country', opt.src_country || (hopt.user_country || '').toLowerCase());
    var qs = zurl.qs_parse_url(location.href, {
      safe: true
    });
    if (qs.debug == 'y') {
      console.log = function () {
        log_to_body.apply(null, arguments);
      };
      console.error = function () {
        log_to_body.apply(null, arguments);
      };
      console.debug = function () {
        log_to_body.apply(null, arguments);
      };
      console.info = function () {
        log_to_body.apply(null, arguments);
      };
      console.log('be.init userAgent ' + navigator.userAgent);
    }
    /* XXX arik/marat: mv this part to www/pub/util.js browser_init() */
    var html = document.getElementsByTagName('html')[0];
    if (E.os_guess.os == 'android') html.className += 'android';
    if (E.br_guess.browser) html.className += E.br_guess.browser;
    E.on('change:developer', _debounce(function () {
      if (E.get('developer')) html.className += 'developer';else html.className = html.className.replace('developer', '');
    }));
    E.on('change:ext.info change:svc.info', _debounce(function () {
      var ext = E.ext(),
        svc = E.svc(),
        cid,
        uuid,
        session_key;
      var enabled;
      if (ext) {
        uuid = ext.uuid;
        session_key = ext.session_key;
        enabled = !ext.disable;
        E.set('ext.enabled', enabled);
        E.set('browser', ext.browser);
        E.unset('svc.unblocker.enabled');
      } else if (svc) {
        session_key = svc.session_key;
        cid = svc.cid;
        enabled = svc.unblocker ? !svc.unblocker.disable : false;
        E.set('svc.unblocker.enabled', enabled);
        E.unset('ext.enabled');
        E.unset('browser');
      }
      E.set('cid', cid);
      E.set('uuid', uuid);
      E.set('enabled', enabled);
      E.set('session_key', session_key);
    }));
    if (!opt.block_unblocking_rate) {
      E.on('change:url_ccgi', _debounce(function () {
        etask([function () {
          return E.get_unblocking_rates(5);
        }, function (unblocking_rate) {
          E.set('unblocking_rate', unblocking_rate);
        }]);
      }));
    }
    E.set('url_ccgi', 'https://' + ccgi_url + '/be_client_cgi');
    E.set('url_perr', 'https://' + perr_url + '/be_client_cgi');
    E.set('ext.info', storage.get_json('unblock.ext.info'));
    E.set('svc.info', storage.get_json('unblock.svc.info'));
    E.set('rules', storage.get_json('unblock.rules'));
    /* XXX shachar: remove unused key from storage */
    storage.clr('unblock.groups');
    storage.clr('unblock.auto_rules');
    update_info_init();
    app_checker.on_svc_detected.push(function () {
      E.refresh_membership({
        skip_bext: opt.skip_bext,
        get_user: opt.get_user
      });
    });
  };

  /* XXX arik hack: rm once moving perr out */
  E.init_perr = function () {
    E.set('url_ccgi', 'https://' + ccgi_url + '/be_client_cgi');
    E.set('url_perr', 'https://' + perr_url + '/be_client_cgi');
  };
  E.uninit = function () {
    if (!E.inited) return;
    E.off();
    if (E.update_info_sp) E.update_info_sp.return();
    E.inited = false;
  };

  /* XXX arik: based on pkg/bext/vpn/util/util.js:get_rules */
  E.get_rules_for_root_url = function (rules, url) {
    url = url || '';
    var _r,
      ret = [],
      r_enabled = null;
    if (!rules) return [];
    for (_r in rules) {
      var r = rules[_r];
      if (r.sid == '2' || !r.supported || r.popup !== undefined && !r.popup) continue;
      var urls = r.root_url;
      if (urls && urls.some(function (rurl) {
        return url.match(rurl);
      })) {
        if (r.enabled) r_enabled = r;else ret.push(r);
      }
    }
    if (r_enabled) ret.unshift(r_enabled);
    return ret;
  };
  E.get_rules_for_apk = function (rules, pkg) {
    var _r,
      ret = [];
    if (!rules) return [];
    for (_r in rules) {
      var r = rules[_r];
      if (!r.root_apk || !r.root_apk.includes(pkg)) continue;
      if (!r.supported || r.popup !== undefined && !r.popup) continue;
      ret.push(r);
    }
    return ret;
  };
  E.get_uuid = function () {
    return E.get('uuid') || qs_o.uuid;
  };

  /* XXX arik: mv to util.js */
  E.perr = function (opt) {
    if (www_util.no_log_perr(opt.id)) return;
    var data = {},
      qs = {};
    qs.cid = opt.cid || E.get('cid');
    qs.uuid = opt.uuid || E.get('uuid') || qs_o.uuid;
    qs.browser = opt.browser;
    qs.id = opt.id;
    qs.ver = opt.ver;
    data.build = E.build();
    data.is_json = 1;
    data.info = opt.info && typeof opt.info != 'string' ? JSON.stringify(opt.info) : opt.info;
    data.bt = opt.bt;
    data.filehead = opt.filehead;
    console.log('perr ' + qs.id + ' ' + data.info);
    return www_util.ajax({
      dataType: 'json',
      type: 'POST',
      data: data,
      url: E.get('url_perr') + '/perr?' + zescape.qs(qs)
    });
  };
  var refresh_membership_counter = 0;
  E.refresh_membership = function (opt) {
    opt = opt || {};
    var current_counter = '(' + refresh_membership_counter + ') ';
    refresh_membership_counter = refresh_membership_counter + 1;
    if (window.postMessage && !opt.skip_bext) {
      window.postMessage({
        src: 'hola_ccgi',
        id: 'refresh_membership',
        data: opt.data
      }, '*');
    }
    var id = (opt.user || !opt.get_user && cookie.getJSON('user') || {})._id || '';
    if (window.location && window.location.protocol == 'chrome:') {
      // XXX dmitriiz: this code is a part of new-tab
      // there is no cookies and we have to just stop this triggering
      // bext will sync session if there is one
      return;
    }
    etask('refresh_membership', [function () {
      return app_checker.get_svc_info();
    }, function (info) {
      if (qs_o.debug_ui) {
        console.log('Debug refresh membership: ', info, opt.get_user, opt.user);
      }
      www_util.session_sync_logs.push(current_counter + 'refresh_membership for id= ' + id);
      if (opt.get_user && !opt.user) {
        return etask('get_user_before_refresh', [function () {
          www_util.session_sync_logs.push(current_counter + 'get_user_before_refresh');
          return opt.get_user();
        }, function (user) {
          if (qs_o.debug_ui) console.log('Debug get_user_before_refresh', user);
          www_util.session_sync_logs.push(current_counter + 'res get_user_before_refresh ' + (user && user.user ? user.user._id : 'no id'));
          if (user && user.user) {
            id = user.user._id;
            E.set('user', user.user);
          }
          return info;
        }]);
      }
      www_util.session_sync_logs.push(current_counter + 'opt.get_user = ' + !!opt.get_user + ' opt.user = ' + !!opt.get_user);
      return info;
    }, function (info) {
      if (!info) return this.return();
      var refresh_premium = id && opt.premium === undefined;
      return etask.all({
        is_premium: refresh_premium ? get_premium() : opt.premium,
        sync_token: id && www_util.get_user_sync_token()
      });
    }, function (res) {
      if (qs_o.debug_ui) console.log('Debug before user_token_update: st=', res.sync_token);
      www_util.session_sync_logs.push('user_token_update with st = ' + res.sync_token);
      if (res.sync_token) {
        if (window.just_called_without_id) {
          if (www_util.session_sync_logs.mark_as_positive_to_send) {
            www_util.perr({
              id: 'www_sync_token_mismatch',
              info: {
                logs: www_util.session_sync_logs
              }
            });
          }
          window.just_called_without_id = false;
        }
      } else {
        window.just_called_without_id = true;
        setTimeout(function () {
          window.just_called_without_id = false;
        }, 10000);
      }
      svc_ipc.ajax({
        cmd: 'user_token_update.json?token=' + id + (res.is_premium ? '&premium' : '') + (res.sync_token ? '&sync=' + res.sync_token : '')
      });
    }]);
  };
  function get_premium() {
    return etask('get_premium', [function () {
      return www_util.get_membership();
    }, function (membership_data) {
      return membership.is_active(membership_data);
    }]);
  }
  E.emitter = new events.EventEmitter();
  E.get_ext_ver = function () {
    return zutil.get(config.get_hola_extension_info(), 'ver');
  };
  E.get_ext_info = function () {
    return config.get_hola_extension_info();
  };
  return E;
});